// 엔터프라이즈 전용 화면 가드 — 구글(베타) 로그인으로 /dcf · /rcps 주소에 직접 들어온 경우 안내만 보인다.
import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../stores/auth";
import { isEnterpriseUser } from "../lib/enterprise";

export default function EnterpriseOnly({ feature, children }: { feature: string; children: ReactNode }) {
  const user = useAuth((s) => s.user);
  const navigate = useNavigate();
  if (!user || isEnterpriseUser(user)) return <>{children}</>;   // 미로그인은 로그인 오버레이가 덮는다
  return (
    <div className="enterprise-only" role="alert">
      <div className="enterprise-only-card">
        <b>{feature}는 딥서치 엔터프라이즈 계정 전용 기능입니다</b>
        <p>구글 계정으로 로그인한 경우 이용할 수 없습니다. 딥서치 계정으로 로그인하면 사용할 수 있습니다.</p>
        <button type="button" onClick={() => navigate("/")}>처음 화면으로</button>
      </div>
    </div>
  );
}
